import React from 'react';
import { IntlProvider } from 'react-intl';
import translations from './translations.json';
import { LANGUAGES } from './languages.js';

const VALID_LANGS = ['en', 'pt', 'es', 'fr', 'it', 'ru', 'de', 'nl', 'ja'];

/**
 * Resolve o idioma a partir de qualquer formato de caminho de URL:
 * Exemplos:
 *  - /pt -> 'pt'
 *  - /pt/5-minutes-timer -> 'pt'
 *  - /stopwatch/pt -> 'pt'
 *  - /focus/de -> 'de'
 *  - /stopwatch -> 'en'
 *  - / -> 'en'
 */
export function resolveLangFromPath(pathname) {
    if (!pathname) return 'en';
    const cleanPath = pathname.split('?')[0].split('#')[0];
    const segments = cleanPath.split('/').filter(Boolean);
    const found = segments.find(seg => VALID_LANGS.includes(seg.toLowerCase()));
    return found ? found.toLowerCase() : 'en';
}

function getInitialLocale() {
    if (typeof window !== 'undefined') {
        const lang = resolveLangFromPath(window.location.pathname);
        const languageObj = LANGUAGES[lang] || LANGUAGES['en'];
        return languageObj.code || 'en-US';
    }
    return IntlProviderConfigured.localeSelected || 'en-US';
}

export default class IntlProviderConfigured extends React.Component {
    state = {
        loading: false,
        locale: getInitialLocale()
    }
    static localeSelected = undefined
    static urlLang = 'en'

    componentDidMount() {
        if (typeof window !== 'undefined') {
            window.addEventListener('popstate', this.syncLocale);
        }
    }

    componentWillUnmount() {
        if (typeof window !== 'undefined') {
            window.removeEventListener('popstate', this.syncLocale);
        }
    }

    syncLocale = () => {
        if (typeof window === 'undefined') return;
        const lang = resolveLangFromPath(window.location.pathname);
        const languageObj = LANGUAGES[lang] || LANGUAGES['en'];
        const targetCode = languageObj.code || 'en-US';
        if (this.state.locale !== targetCode) {
            this.setState({ locale: targetCode, loading: false });
        }
    }

    static preInitStore(url) {
        return new Promise((resolve) => {
            const lang = resolveLangFromPath(url);
            const languageObj = LANGUAGES[lang] || LANGUAGES['en'];
            IntlProviderConfigured.localeSelected = languageObj.code || 'en-US';
            IntlProviderConfigured.urlLang = languageObj.urlLang || 'en';
            resolve(true);
        });
    }

    render() {
        const locale = (this.state.locale !== '' && this.state.locale)
            ? this.state.locale
            : (IntlProviderConfigured.localeSelected || 'en-US');

        const { children } = this.props;

        if (this.state.loading && IntlProviderConfigured.localeSelected === undefined) return <div>...</div>;

        return (
            <IntlProvider
                locale={locale}
                messages={translations[locale] || translations['en-US']}
                defaultRichTextElements={{
                    strong: (chunks) => <strong>{chunks}</strong>,
                }}
            >
                {children}
            </IntlProvider>
        );
    }
}